import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Dialog } from 'antd-mobile'
import { create } from '../../api/orderService'
import { USER_TOKEN_KEY } from '../../constants/localStorageConstants'

interface OrderFormValues {
  name: string
  idCard: string
  phone: string
  smsCode: string
  employeeCode?: string
  companyName?: string
  companyCreditCode?: string
  ticket?: string
  randstr?: string
  [key: string]: any
}

interface UseOrderCreationOptions {
  linkId: string
  employeeId: string
  templateName?: String | string
  templatePrice?: String | string | Number | number
  getRoutersString: () => string
}

export function useOrderCreation({
  linkId,
  employeeId,
  templateName,
  templatePrice,
  getRoutersString,
}: UseOrderCreationOptions) {
  const [loading, setLoading] = useState(false)
  const navigate = useNavigate()

  const createOrder = async (values: OrderFormValues) => {
    setLoading(true)
    try {
      const data = await create({
        ...values,
        linkId: linkId,
        employeeId: employeeId,
        employeeCode: values.employeeCode || '',
        ticket: values.ticket || '',
        randstr: values.randstr || '',
      })

      localStorage.setItem(USER_TOKEN_KEY, data.token?.tokenValue)

      if (data.status === 35) {
        Dialog.alert({
          content: '请联系代理商确认报告。',
          onConfirm: () => {},
        })
        return
      }

      navigate(
        '/payment?orderId=' +
          data.orderId +
          '&templateName=' +
          templateName +
          '&templatePrice=' +
          templatePrice +
          '&routers=' +
          getRoutersString()
      )
    } catch (error) {
      console.error('Order creation failed:', error)
    } finally {
      setLoading(false)
    }
  }

  return {
    createOrder,
    loading,
  }
}
